// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editOrderPage .addressModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  outline: 0;
}
.editOrderPage .addressModalContent {
  width: 700px;
  max-height: 95%;
  overflow: scroll;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%) !important;
  margin: 0 auto;
  background-color: white;
  padding: 30px;
  border-radius: var(--border-radius);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
}
.editOrderPage .closeModal {
  cursor: pointer;
}
.editOrderPage .isShippingAddress label {
  margin-bottom: 0;
  margin-left: 10px;
}
.editOrderPage .isShippingAddress input {
  vertical-align: unset;
  height: auto;
}
.editOrderPage .recipients {
  width: 30%;
  padding-top: 5px;
}

.editOrderPage .recipients div {
  /* padding-bottom: 10px; */
}
.editOrderPage table.table tr td {
  vertical-align: top;
}
.display_line_2{
  display: block;
}

.display_value{
  display: block;
}

.recipients_detail div{
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.recipients_detail p{
  font-size: 12px;
}

.product_details{
  width: 100px;
}

.editAddress .card{
  max-height: 95vh;
  overflow-y: scroll;
}

.editOrderPage table.table tr td .personalization {
  display: flex;
  min-height: 110px;
}
.editOrderPage .itemImg {
  width: 10%;
}
.editOrderPage .itemImg img {
  width: 100%;
}
.editOrderPage .billingAddress {
  cursor: pointer;
}
.alert.alertMsg {
  padding: 0;
  margin: 0;
}


.reference-input input {
  margin-bottom: 0 !important;
}


.order_status_loader_container{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}


.order_status_loader{
  height: 50px;
  position: relative;
}

.customer_navigation_arrow{
  display: flex;
  justify-content: end;
  align-items: end;
}

.customer_navigation_arrow svg{
  cursor: pointer;
}

.shipdate .form-control{
  padding: 4px 3px !important;
}

.edit_order .table.table tr td{
  padding-right: 7px !important ;
  padding-left: 7px !important;
  font-size: 12px;
}

.edit_order .table.table tr th{
  padding-right: 7px !important ;
  padding-left: 7px !important;
}

`, "",{"version":3,"sources":["webpack://./src/Components/OrdersForMultipleAddress/EditOrder/EditOrder.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;AACX;;;AAGA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B","sourcesContent":[".editOrderPage .addressModal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: hidden;\n  outline: 0;\n}\n.editOrderPage .addressModalContent {\n  width: 700px;\n  max-height: 95%;\n  overflow: scroll;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 99;\n  transform: translate(-50%, -50%) !important;\n  margin: 0 auto;\n  background-color: white;\n  padding: 30px;\n  border-radius: var(--border-radius);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);\n}\n.editOrderPage .closeModal {\n  cursor: pointer;\n}\n.editOrderPage .isShippingAddress label {\n  margin-bottom: 0;\n  margin-left: 10px;\n}\n.editOrderPage .isShippingAddress input {\n  vertical-align: unset;\n  height: auto;\n}\n.editOrderPage .recipients {\n  width: 30%;\n  padding-top: 5px;\n}\n\n.editOrderPage .recipients div {\n  /* padding-bottom: 10px; */\n}\n.editOrderPage table.table tr td {\n  vertical-align: top;\n}\n.display_line_2{\n  display: block;\n}\n\n.display_value{\n  display: block;\n}\n\n.recipients_detail div{\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.recipients_detail p{\n  font-size: 12px;\n}\n\n.product_details{\n  width: 100px;\n}\n\n.editAddress .card{\n  max-height: 95vh;\n  overflow-y: scroll;\n}\n\n.editOrderPage table.table tr td .personalization {\n  display: flex;\n  min-height: 110px;\n}\n.editOrderPage .itemImg {\n  width: 10%;\n}\n.editOrderPage .itemImg img {\n  width: 100%;\n}\n.editOrderPage .billingAddress {\n  cursor: pointer;\n}\n.alert.alertMsg {\n  padding: 0;\n  margin: 0;\n}\n\n\n.reference-input input {\n  margin-bottom: 0 !important;\n}\n\n\n.order_status_loader_container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n\n.order_status_loader{\n  height: 50px;\n  position: relative;\n}\n\n.customer_navigation_arrow{\n  display: flex;\n  justify-content: end;\n  align-items: end;\n}\n\n.customer_navigation_arrow svg{\n  cursor: pointer;\n}\n\n.shipdate .form-control{\n  padding: 4px 3px !important;\n}\n\n.edit_order .table.table tr td{\n  padding-right: 7px !important ;\n  padding-left: 7px !important;\n  font-size: 12px;\n}\n\n.edit_order .table.table tr th{\n  padding-right: 7px !important ;\n  padding-left: 7px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
